import React from 'react';
import './styles.css';
import { COMMENT_OPEN, COMMENT_CLOSED } from '@BUP/constants';
import { Row, Col, Button, Tag, Tooltip } from 'antd';
import { useHistory, useLocation } from "react-router-dom";
import { getMessageCreatorInfo } from '@BUP/services/BraveUp';
import { RBAC } from '@BUP/components';
import {
  CheckCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import 'moment/locale/es';

const MessageElement = ({ message, handleSetMessageState }) => {
  const history = useHistory();
  const location = useLocation();
  const { messageCreator } = getMessageCreatorInfo(message);
  const isOpenMessage = message?.state === COMMENT_OPEN ? true : false;

  return (
    <div className="message-element-container">
      <Row style={{ flex: 1, padding: 15 }}>
        <Col xs={24} className="content-element" style={{ justifyContent: 'space-between' }}>
          <div className="info-wrapper">
            <p style={{ margin: 0 }}>
              {messageCreator}
            </p>
          </div>
          <RBAC name="messageListStateTag">
            <div className="info-wrapper">
              <Tooltip 
                placement="top" 
                title="Estado del caso."
              >
                {
                  isOpenMessage ?
                    (
                      <Tag style={{ margin: 0 }} icon={<CheckCircleOutlined />} color="success">
                        ABIERTO
                      </Tag>
                    ) :
                    (
                      <Tag style={{ margin: 0 }} icon={<MinusCircleOutlined />} color="default">
                        CERRADO
                      </Tag>
                    )
                }
              </Tooltip>
            </div>
          </RBAC>
        </Col>
        <Col xs={24} className="content-element message-wrapper">
          <span>
            {message?.content || ""}
          </span>
        </Col>
        <Col xs={24} className="content-element date-wrapper">
          {
            `${moment(message?.createdAt).format('lll')}    
            (${moment(message?.createdAt).fromNow()})`
          }
          <div>
            <RBAC
              name="openOrCloseMessageButton"
            >
              <Button
                type="primary"
                ghost={true}
                style={{ fontWeight: 'bold' }}
                onClick={async () => {
                  const newState = isOpenMessage ? COMMENT_CLOSED : COMMENT_OPEN
                  return await handleSetMessageState(message.id, newState)
                }}
              >
                {isOpenMessage ? "Archivar Caso" : "Abrir Caso"}
              </Button>
            </RBAC>
            <Button
              type="primary"
              style={{
                fontWeight: 'bold',
                marginLeft: 10
              }}
              onClick={() => {
                history.push({
                  pathname: `/modebup/direct`,
                  mainMessage: message,
                  messageCreator: messageCreator,
                  prevLocation: location
                })
              }}
            >
              {isOpenMessage ? "Abrir" : "Revisar"}
            </Button>
          </div>
        </Col>
        <Col xs={24} className="content-element button-wrapper">
        </Col>
      </Row>
    </div>
  )
}

export default MessageElement;